(function () {

  'use strict';



  // Karta podarunkowa — nominały, własna kwota, AJAX → koszyk

  var root = document.querySelector('[data-cw-gift-card]');

  if (!root) {

    return;

  }



  var cfg = window.customwearGiftCard || {};

  var i18n = cfg.i18n || {};

  var amountEls = root.querySelectorAll('[data-cw-gift-card-amount]');

  var recipientEls = root.querySelectorAll('[data-cw-gift-card-recipient]');

  var totalEl = root.querySelector('[data-cw-gift-card-total]');

  var denomBtns = root.querySelectorAll('[data-cw-gift-card-denom]');

  var recipientInput = root.querySelector('#cw-gift-card-recipient');

  var messageInput = root.querySelector('#cw-gift-card-message');

  var customInput = root.querySelector('#cw-gift-card-custom-amount');

  var customBtn = root.querySelector('[data-cw-gift-card-custom-apply]');

  var form = root.querySelector('[data-cw-gift-card-form]');

  var statusEl = root.querySelector('[data-cw-gift-card-status]');

  var submitBtn = root.querySelector('[data-cw-gift-card-submit]');



  var selectedAmount = Number(cfg.defaultAmount) || 100;

  var minAmount = Number(cfg.minAmount) || 50;

  var maxAmount = Number(cfg.maxAmount) || 5000;

  var busy = false;



  function formatAmount(val) {

    return String(val) + ' zł';

  }



  function setStatus(msg, isError) {

    if (!statusEl) {

      return;

    }

    if (!msg) {

      statusEl.hidden = true;

      statusEl.textContent = '';

      statusEl.classList.remove('is-error');

      return;

    }

    statusEl.hidden = false;

    statusEl.textContent = msg;

    statusEl.classList.toggle('is-error', !!isError);

  }



  function updatePreview() {

    var label = formatAmount(selectedAmount);

    amountEls.forEach(function (el) {

      el.textContent = label;

    });

    if (totalEl) {

      totalEl.textContent = label;

    }

  }



  function updateRecipient() {

    var name = recipientInput ? String(recipientInput.value || '').trim() : '';

    var text = name

      ? String(i18n.recipientPrefix || 'DLA:') + ' ' + name.toUpperCase()

      : String(i18n.recipientFallback || 'DLA: TWOJEJ WYBRANEJ OSOBY');

    recipientEls.forEach(function (el) {

      el.textContent = text;

    });

  }



  function clearDenomSelection() {

    denomBtns.forEach(function (b) {

      b.classList.remove('is-selected');

      b.setAttribute('aria-pressed', 'false');

    });

  }



  function syncSelectedDenom(btn) {

    denomBtns.forEach(function (b) {

      var on = b === btn;

      b.classList.toggle('is-selected', on);

      b.setAttribute('aria-pressed', on ? 'true' : 'false');

    });

    selectedAmount = Number(btn.getAttribute('data-cw-gift-card-denom')) || selectedAmount;

    if (customInput) {

      customInput.value = '';

    }

    updatePreview();

    setStatus('');

  }



  function applyCustomAmount() {

    if (!customInput) {

      return false;

    }

    var raw = String(customInput.value || '').trim().replace(',', '.');

    var val = Math.round(Number(raw));

    if (!val || val < minAmount || val > maxAmount) {

      setStatus(String(i18n.invalidAmount || ''), true);

      return false;

    }

    selectedAmount = val;

    clearDenomSelection();

    updatePreview();

    setStatus('');

    return true;

  }



  denomBtns.forEach(function (btn) {

    btn.addEventListener('click', function () {

      syncSelectedDenom(btn);

    });

  });



  if (customBtn) {

    customBtn.addEventListener('click', function () {

      applyCustomAmount();

    });

  }



  if (customInput) {

    customInput.addEventListener('keydown', function (ev) {

      if (ev.key === 'Enter') {

        ev.preventDefault();

        applyCustomAmount();

      }

    });

    customInput.addEventListener('change', function () {

      if (String(customInput.value || '').trim() !== '') {

        applyCustomAmount();

      }

    });

  }



  if (recipientInput) {

    recipientInput.addEventListener('input', updateRecipient);

  }



  root.querySelectorAll('.cw-gift-card__reveal').forEach(function (el) {

    el.classList.add('is-visible');

  });



  function addToCart() {

    if (busy) {

      return;

    }

    if (customInput && String(customInput.value || '').trim() !== '') {

      if (!applyCustomAmount()) {

        return;

      }

    }

    if (!selectedAmount || selectedAmount < minAmount || selectedAmount > maxAmount) {

      setStatus(String(i18n.invalidAmount || ''), true);

      return;

    }

    if (!cfg.ajaxUrl || !cfg.nonce) {
      setStatus(String(i18n.pending || ''), true);
      return;
    }



    busy = true;

    if (submitBtn) {

      submitBtn.disabled = true;

      submitBtn.textContent = String(i18n.adding || 'Dodawanie…');

    }

    setStatus('');



    var body = new FormData();

    body.append('action', 'customwear_gift_card_add');

    body.append('nonce', String(cfg.nonce || ''));

    body.append('amount', String(selectedAmount));

    body.append('recipient', recipientInput ? String(recipientInput.value || '') : '');

    body.append('message', messageInput ? String(messageInput.value || '') : '');



    fetch(String(cfg.ajaxUrl), {

      method: 'POST',

      body: body,

      credentials: 'same-origin',

    })

      .then(function (r) {

        return r.json();

      })

      .then(function (data) {

        if (!data || !data.success) {

          var msg =

            data && data.data && data.data.message

              ? data.data.message

              : String(i18n.pending || '');

          setStatus(msg, true);

          return;

        }

        setStatus(String((data.data && data.data.message) || i18n.added || ''), false);

        var cartUrl = (data.data && data.data.cart_url) || cfg.cartUrl;

        if (cartUrl) {

          window.location.href = cartUrl;

        }

      })

      .catch(function () {

        setStatus(String(i18n.pending || ''), true);

      })

      .finally(function () {

        busy = false;

        if (submitBtn) {

          submitBtn.disabled = false;

          submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Dodaj do koszyka';

        }

      });

  }



  if (submitBtn) {

    submitBtn.setAttribute('data-label', submitBtn.textContent || 'Dodaj do koszyka');

  }



  if (form) {

    form.addEventListener('submit', function (ev) {

      ev.preventDefault();

      addToCart();

    });

  }



  updatePreview();

  updateRecipient();

})();


